import React, { useMemo } from "react";
import PropTypes from "prop-types";
import ProviderHeader from "./ProviderHeader";
import ProviderDetailsLeft from "./ProviderDetailsLeft";
import ProviderDetailsRight from "./ProviderDetailsRight";

const ViewProviderDetailsTable = ({ details, languageData }) => {
  const everydays =
    languageData == "en"
      ? ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
      : ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"];

  const {
    personalDetails = {},
    isTelemedicine = null,
    telemedModalities = null,
    telemedCaregiverAccess = "",
    specialityList = {},
    educationList = {},
    languageList = {},
    hospitalAffiliationList = {},
    npi1 = null,
  } = details?.providerDetails?.practitioner ?? {};

  const officeStateAbbreviations = useMemo(() => {
    const offices = details?.officeList?.office;
    if(!offices || offices.length === 0) {
      return [];
    }

    return [...new Set(offices.map((office) => office?.address?.domesticAddress?.state?.stateAbbreviation).filter((abbr) => abbr != null))];
  }, [details?.officeList?.office]);

  return (
    <>
      <ProviderHeader
        personalDetails={personalDetails}
        educationList={educationList}
        specialityList={specialityList}
        isTelemedicine={isTelemedicine}
        telemedModalities={telemedModalities}
        telemedCaregiverAccess={telemedCaregiverAccess}
        languageData={languageData}
      />
      <div className="details-main">
        <div className="details-left">
          <ProviderDetailsLeft
            personalDetails={personalDetails}
            educationList={educationList}
            languageList={languageList}
            specialityList={specialityList}
            hospitalAffiliationList={hospitalAffiliationList}
            npi1={npi1}
            officeStateAbbreviations={officeStateAbbreviations}
          />
        </div>

        <div className="details-right">
          <ProviderDetailsRight
            officeList={details?.officeList}
            everydays={everydays}
          />
        </div>
      </div>
    </>
  );
};

ViewProviderDetailsTable.propTypes = {
  details: PropTypes.object,
  languageData: PropTypes.string,
};

export default ViewProviderDetailsTable;
